import { render, staticRenderFns } from "./HrDossierInfoDetail.vue?vue&type=template&id=bb3c091e&scoped=true&"
import script from "./HrDossierInfoDetail.vue?vue&type=script&lang=js&"
export * from "./HrDossierInfoDetail.vue?vue&type=script&lang=js&"
import style0 from "./HrDossierInfoDetail.vue?vue&type=style&index=0&id=bb3c091e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb3c091e",
  null
  
)

export default component.exports